import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DiscountProduct } from '../models/discount-product';
import { SelectedRewardProductDto } from '../models/selected-reward-product-dto';

@Injectable({
  providedIn: 'root'
})
export class MyDiscountService {

  constructor(
    private http: HttpClient,
  ) { }

  getActiveDiscountProducts(url: string, customerCode: string) {
    return this.http.get<DiscountProduct[]>(url + "/" + customerCode);
  }

  getActiveOffers(url: string, customerCode: string, productCode: number, festivalDiscountSetupCode: number) {
    return this.http.get<SelectedRewardProductDto>(url + "/" + customerCode + "/" + productCode + "/" + festivalDiscountSetupCode);
  }

  saveRating(url: string, dynamuicCode: string, rating: number) {
    return this.http.patch(url + "/" + dynamuicCode + "/" + rating, null);
  }
}
